import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SidePanel from "layouts/SidePanel";
import Leads from "./Leads";
import { FilterSection } from "views/CompanyDirectory/components";
import FilterLeads from "./FilterLeads";
import { isWithinInterval, parseISO } from "date-fns";
import { fetchLeads } from "actions/leadsAction";

const LeadsNew = () => {
    const dispatch = useDispatch();
    const lead = useSelector((state) => state.lead);
    const userProfile = useSelector((state) => state.auth.user);
    const loading = lead.loading;
    // console.log("aaaaaaa", loading);
    let companyData = Array.isArray(lead?.counts?.companies)
        ? lead.counts.companies.map((company) => ({
            companyName: company.companyName,
            count: company.count || 0,
            clients: Array.isArray(company.clients) ? company.clients : [],
        }))
        : [];

    // Fallback for older/non-paginated responses.
    if (!companyData.length) {
        lead?.leads.forEach((leadItem) => {
            const companyName = leadItem.userBusinessName;
            const requesterName = leadItem.requesterName;

            const existingCompany = companyData.find((company) => company.companyName === companyName);

            if (existingCompany) {
                existingCompany.count += 1;
                if (!existingCompany.clients.includes(requesterName)) {
                    existingCompany.clients.push(requesterName);
                }
            } else {
                companyData.push({
                    companyName,
                    count: 1,
                    clients: [requesterName],
                });
            }
        });
    }

    // console.log(companyData);
    const navigate = useNavigate();
    const [openFilters, setOpenFilters] = useState(false);

    const handleFilters = (value) => {
        console.log("Applying Filter:", value);
        setFilters({ quotationReceived: value });
    };


    const handleMyBusiness = () => {
        navigate("/my-business")
    }
    const handleLeads = () => {
        navigate("/leads")
    }


    const [filters, setFilters] = useState({
        date: "all", // 'last7Days', 'lastMonth', or 'all'
        status: "all", // 'open', 'closed', or 'all'
        quotationReceived: null,
        rfqType: ["all"], // Default to show all
        companyName: [],  // Ensure companyName is always an array
        client: []        // Ensure client is always an array
    });


    const [showAll, setShowAll] = useState(false);
    const [showFilters, setShowFilters] = useState(false); // State to control slider visibility
    const [currentPage, setCurrentPage] = useState(1);
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
    const leadsPageSize = 100;


    const monthNames = [
        "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12",
    ];

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const getRfqStatusClass = (status) => {
        switch (status) {
            case "DRAFT":
                return "bg-yellow-200 text-yellow-950";
            case "CLOSED":
            case "EXPIRED":
                return "bg-red-200 text-red-950";
            case "CANCELED":
                return "bg-gray-200 text-gray-950";
            case "DELETED":
                return "bg-cyan-200 text-cyan-950";
            case "HOLD":
                return "bg-purple-200 text-purple-950";
            case "OPEN":
                return "bg-green-100 text-green-800";
            case "PENDING APPROVAL":
                return "bg-orange-200 text-orange-800";
            case "REWORK":
                return "bg-green-100 text-green-800";
            default:
                return "bg-slate-100 text-slate-800";
        }
    };

    const formatRfqStatus = (status) => {
        if (!status) return "N/A";

        const normalizedStatus = String(status).trim().toUpperCase();
        if (normalizedStatus === "PENDING APPROVAL") return "In Review";
        if (normalizedStatus === "REWORK") return "Open";

        return status
            .toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    const isLeadClosed = (leadItem) =>
        String(leadItem?.status || "").trim().toUpperCase() === "CLOSED";

    const getQuotationActionLabel = (leadItem) => {
        if (!leadItem?.suppliers?.[0]?.quotationReceived) return "Add Quotation";
        return isLeadClosed(leadItem) ? "View Quotation" : "Edit Quotation";
    };


    const getLeadAwardSummary = (leadItem) => leadItem?.awardSummary || leadItem?.suppliers?.[0]?.awardSummary;

    const getAwardStatusClass = (awardType) => {
        switch (awardType) {
            case "FULL":
                return "bg-emerald-100 text-emerald-800 border-emerald-200";
            case "PARTIAL":
                return "bg-amber-100 text-amber-800 border-amber-200";
            case "NOT_AWARDED":
                return "bg-rose-100 text-rose-800 border-rose-200";
            default:
                return "bg-slate-100 text-slate-600 border-slate-200";
        }
    };

    const renderAwardStatusBadge = (leadItem) => {
        const awardSummary = getLeadAwardSummary(leadItem);

        if (!awardSummary?.applicable) {
            return <span className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium text-slate-500">-</span>;
        }

        return (
            <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap ${getAwardStatusClass(awardSummary.awardType)}`}>
                {awardSummary.label || "-"}
            </span>
        );
    };

    const formatAwardAmount = (amount) => {
        const value = Number(amount || 0);
        if (!value) return "-";
        return value.toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0,
        });
    };

    const renderAwardedAmount = (leadItem) => {
        const awardSummary = getLeadAwardSummary(leadItem);
        if (!awardSummary?.applicable || !awardSummary?.isAwarded) return "-";
        return formatAwardAmount(awardSummary.awardedAmount);
    };
    const handleDateRangeChange = ({ startDate, endDate }) => {
        setFilters((prev) => ({
            ...prev,
            startDate,
            endDate,
        }));
    };


    const handleFilterChange = (key, value) => {
        setFilters((prev) => {
            let updatedFilters = { ...prev };

            if (key === "companyName") {
                let updatedCompanyNames = [...prev.companyName];

                if (value === "all") {
                    updatedCompanyNames = ["all"]; // Select all companies
                } else if (updatedCompanyNames.includes(value)) {
                    updatedCompanyNames = updatedCompanyNames.filter((company) => company !== value);
                } else {
                    updatedCompanyNames.push(value);
                }

                // Ensure "all" is removed when specific company names are selected
                if (updatedCompanyNames.includes("all")) {
                    updatedCompanyNames = updatedCompanyNames.filter((company) => company !== "all");
                }

                updatedFilters.companyName = updatedCompanyNames;

                // Ensure client filter corresponds with selected company
                if (!updatedCompanyNames.length) {
                    updatedFilters.client = [];
                }

            } else if (key === "client") {
                let updatedClients = [...prev.client];

                if (value === "all") {
                    updatedClients = ["all"]; // Select all clients
                } else if (updatedClients.includes(value)) {
                    updatedClients = updatedClients.filter((client) => client !== value);
                } else {
                    updatedClients.push(value);
                }

                // Ensure "all" is removed when specific clients are selected
                if (updatedClients.includes("all")) {
                    updatedClients = updatedClients.filter((client) => client !== "all");
                }

                updatedFilters.client = updatedClients;

            } else if (key === "rfqType") {
                let updatedRfqTypes = [...prev.rfqType];

                if (value === "all") {
                    updatedRfqTypes = ["all"]; // Select all rfqType categories
                } else if (updatedRfqTypes.includes(value)) {
                    updatedRfqTypes = updatedRfqTypes.filter((type) => type !== value);
                } else {
                    updatedRfqTypes.push(value);
                }

                // Ensure "all" is removed when specific categories are selected
                if (updatedRfqTypes.includes("all")) {
                    updatedRfqTypes = updatedRfqTypes.filter((type) => type !== "all");
                }

                if (updatedRfqTypes.length === 0) {
                    updatedRfqTypes = ["all"];
                }

                updatedFilters.rfqType = updatedRfqTypes;
            } else {
                setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
            }

            return updatedFilters;
        });
    };



    useEffect(() => {
        setCurrentPage(1);
    }, [filters]);

    useEffect(() => {
        if (!loading && (Array.isArray(lead?.leads) || lead?.pagination || lead?.counts)) {
            setHasLoadedOnce(true);
        }
    }, [loading, lead?.leads, lead?.pagination, lead?.counts]);

    useEffect(() => {
        if (!userProfile?.userId) return;

        dispatch(fetchLeads(userProfile?.vendorsIn, userProfile?.userId, {
            pagination: {
                page: currentPage,
                limit: leadsPageSize,
            },
            filters,
        }));
    }, [dispatch, userProfile?.userId, userProfile?.vendorsIn, currentPage, filters]);
    const filterByDate = (lead) => {
        const createdDate = new Date(lead.createdAt);
        const now = new Date();

        if (filters.date === "last7Days") {
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(now.getDate() - 7);
            return createdDate >= sevenDaysAgo;
        }

        if (filters.date === "lastMonth") {
            const lastMonth = new Date();
            lastMonth.setMonth(now.getMonth() - 1);
            return createdDate >= lastMonth && createdDate <= now;
        }
        // Custom Date Range Filter
        if (filters.date === "custom" && filters.startDate && filters.endDate) {
            const startDate = new Date(filters.startDate);
            const endDate = new Date(filters.endDate);
            endDate.setHours(23, 59, 59, 999); // Include the full end date
            return createdDate >= startDate && createdDate <= endDate;
        }

        return true; // Show all leads for "all"
    };

    const filterByRfqType = (lead) => {
        return filters?.rfqType?.includes("all") ||
            filters?.rfqType?.includes(lead?.rfqType?.toLowerCase());
    };


    // console.log("filters", filters)

    const openQuotationForm = (rfq) => {
        // Correct way to determine if we're editing an existing quotation
        const isEdit = rfq?.suppliers?.[0]?.quotationReceived === true;
        const isReadOnly = rfq?.status === "PENDING APPROVAL" || rfq?.status === "CLOSED";
    
        switch (rfq?.rfqType) {
            case "material":
                if (rfq?.materials && rfq.materials.length > 0) {
                    // Path construction based on the isEdit flag
                    const path = isEdit
                        ? `/material-form?rfqId=${rfq?.rfqId}&isEdit=true&rfqType=${rfq?.rfqType}`
                        : `/material-form?rfqId=${rfq?.rfqId}&isEdit=false&rfqType=${rfq?.rfqType}`;
    
                    if (isReadOnly) {
                        navigate(`${path}&readOnly=true`, {
                            state: { 
                                rfqData: rfq, 
                                isEdit, 
                                supplierId: rfq?.suppliers[0]?.supplierId,
                                // quotationIndex: isEdit ? 0 : undefined 
                            }
                        });
                    } else {
                        navigate(path, {
                            state: { 
                                rfqData: rfq, 
                                isEdit, 
                                supplierId: rfq?.suppliers[0]?.supplierId,
                                // quotationIndex: isEdit ? 0 : undefined
                            }
                        });
                    }
                } else {
                    console.warn("Materials data is missing or empty.");
                    // Consider showing a user-friendly message here
                }
                break;
    
            case "labour":
                if (rfq?.labourDetails && rfq.labourDetails.length > 0) {
                    const path = isEdit
                        ? `/labour-form?rfqId=${rfq?.rfqId}&isEdit=true&rfqType=${rfq?.rfqType}`
                        : `/labour-form?rfqId=${rfq?.rfqId}&isEdit=false&rfqType=${rfq?.rfqType}`;
                    navigate(`${path}${isReadOnly ? "&readOnly=true" : ""}`, {
                        state: { rfqData: rfq, isEdit, supplierId: rfq?.suppliers[0]?.supplierId }
                    });
                } else {
                    console.warn("Labour details are missing or empty.");
                    // Optional: Show alert or handle missing labour data
                }
                break;
    
            case "contractor":
                if (rfq?.providingFixingDetails) {
                    const path = isEdit
                        ? `/providing-form?rfqId=${rfq?.rfqId}&isEdit=true&rfqType=${rfq?.rfqType}`
                        : `/providing-form?rfqId=${rfq?.rfqId}&isEdit=false&rfqType=${rfq?.rfqType}`;
                    navigate(`${path}${isReadOnly ? "&readOnly=true" : ""}`, {
                        state: { rfqData: rfq, isEdit, supplierId: rfq?.suppliers[0]?.supplierId }
                    });
                } else {
                    console.warn("Contractor details are missing or empty.");
                    // Optional: Show alert or handle missing contractor data
                }
                break;
    
            default:
                console.warn("Invalid RFQ type.");
            // Optional: Handle invalid RFQ type if necessary
        }
    }

    const filterByStatus = (lead) => {
        if (filters.status === "OPEN") {
            return lead.status === "OPEN";
        }

        if (filters.status === "CLOSED") {
            return lead.status === "CLOSED";
        }

        if (filters.status === "HOLD") {
            return lead.status === "HOLD";
        }

        return true; // Show all leads for "all"
    };

    const filterBySubmission = (lead) => {
        if (filters.quotationReceived === null) {
            return true; // No filter, show all leads
        }
        if (filters.quotationReceived) {
            return (lead.suppliers[0].quotationReceived === filters.quotationReceived);
        }
        return (lead.suppliers[0].quotationReceived === filters.quotationReceived && lead?.status !== "CLOSED")
    };

    const filterByCompanyAndClient = (lead) => {
        // Check if any company names are selected
        const isCompanyFiltered = filters.companyName.length > 0 && !filters.companyName.includes("all");

        // Check if any client names are selected
        const isClientFiltered = filters.client.length > 0 && !filters.client.includes("all");

        // If company names are filtered, check if the lead's company is included in the filter
        const isCompanyMatch = isCompanyFiltered
            ? filters.companyName.includes(lead.userBusinessName.toLowerCase())
            : true;

        // If client names are filtered, check if the lead's client is included in the filter
        const isClientMatch = isClientFiltered
            ? filters.client.includes(lead.requesterName.toLowerCase())
            : true;

        // Return true if both company and client match the filters, or if no filtering is applied
        return isCompanyMatch && isClientMatch;
    };

    const filterByDateRange = (lead) => {
        if (!filters.startDate || !filters.endDate) return true; // No filter applied

        const leadDate = new Date(lead.createdAt).setHours(0, 0, 0, 0); // Normalize time
        const start = new Date(filters.startDate).setHours(0, 0, 0, 0);
        const end = new Date(filters.endDate).setHours(23, 59, 59, 999); // Include full day

        return leadDate >= start && leadDate <= end;
    };



    const filteredLeads = (lead?.leads || [])
        .filter(filterByDate)
        .filter(filterByStatus)
        .filter(filterByRfqType);

    const handleToggleView = () => {
        setShowAll((prevState) => !prevState);
    };

    const sortedLeads = (lead?.leads || [])
        .filter(filterByDate)
        .filter(filterBySubmission)
        .filter(filterByRfqType)
        .filter(filterByCompanyAndClient)
        .filter(filterByDateRange)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Newest first
    const pagination = lead?.pagination;
    const totalLeads = pagination?.total ?? sortedLeads.length;
    const activePage = pagination?.page || currentPage;
    const activeLimit = pagination?.limit || leadsPageSize;
    const totalPages = pagination?.totalPages || Math.max(Math.ceil(totalLeads / activeLimit), 1);
    const pageStart = totalLeads ? ((activePage - 1) * activeLimit) + 1 : 0;
    const pageEnd = Math.min(activePage * activeLimit, totalLeads);
    const isInitialLeadsLoading = loading && !hasLoadedOnce;
    const isTableRefreshing = loading && hasLoadedOnce;

    const renderPaginationControls = () => {
        if (!pagination || totalLeads <= activeLimit) return null;

        return (
            <div className="flex flex-wrap items-center justify-between gap-3 border-t border-gray-200 bg-white px-4 py-3 text-xs text-gray-600 shadow-[0_-6px_18px_rgba(15,23,42,0.08)]">
                <span className="font-medium">
                    Showing {pageStart}-{pageEnd} of {totalLeads} leads
                </span>
                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        disabled={activePage <= 1}
                        onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
                        className="rounded border border-gray-300 px-3 py-1 font-medium disabled:cursor-not-allowed disabled:opacity-40"
                    >
                        Previous
                    </button>
                    <span className="rounded bg-orange-50 px-3 py-1 font-semibold text-orange-700">
                        Page {activePage} of {totalPages}
                    </span>
                    <button
                        type="button"
                        disabled={activePage >= totalPages}
                        onClick={() => setCurrentPage((page) => Math.min(page + 1, totalPages))}
                        className="rounded border border-gray-300 px-3 py-1 font-medium disabled:cursor-not-allowed disabled:opacity-40"
                    >
                        Next
                    </button>
                </div>
            </div>
        );
    };

    const tableHeaders = [
        { key: "createdAt", label: "Created Date" },
        { key: "rfqId", label: "RFQ No." },
        { key: "quotationReceived", label: "Quotation Status" },
        { key: "status", label: "RFQ Status" },
        { key: "name", label: "RFQ Subject" },
        // { key: "rfqType", label: "Requirement Type" },
        { key: "actions", label: "Actions" },
        { key: "projectName", label: "Project Name" },
        { key: "userBusinessName", label: "Client Company Name" },
        { key: "requesterName", label: "Client Name" },
        { key: "requesterContact", label: "Client Contact" },
        { key: "requestedBy", label: "Client Email" },
        { key: "awardSummary", label: "Award Status" },
        { key: "awardedAmount", label: "Awarded Amount" },
        // { key: "status", label: "Requirement Status" },
    ];

    // console.log("aaaaaaa", sortedLeads);

    return (
        <div className="bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF] h-full">
            <>
                <div className="bg-gray-950 lg:hidden flex justify-between items-center px-6 sticky top-0 z-20 shadow-md p-4">
                    <div>
                        <div className='flex justify-between md:space-x-8 xl:space-x-[36px] items-center font-semibold text-sm text-white'>
                            <img
                                src='https://storagereponeevaydevcdn.blob.core.windows.net/business/NEEVAY_LOGO_email.png'
                                alt='Neevay'
                                className='w-[104px] md:w-[97px] xl:w-[120px] h-full cursor-pointer'
                                onClick={() => navigate('/')}  // Moved onClick here
                            />
                        </div>
                    </div>
                    {/* Clickable Hamburger Image */}
                    <div
                        className="ml-[22px] cursor-pointer flex flex-col justify-between w-6 h-5"
                        onClick={() => setShowFilters(true)}
                    >
                        <span className="block h-0.5 bg-white"></span>
                        <span className="block h-0.5 bg-white"></span>
                        <span className="block h-0.5 bg-white"></span>
                    </div>

                </div>
                {/* Slide-in Filter Panel */}
                <div className={`fixed top-0 right-0 lg:hidden w-80 overflow-y-auto h-full bg-white shadow-lg transform transition-transform duration-300 z-30 ${showFilters ? "translate-x-0" : "translate-x-full"}`}>
                    {/* Close Button */}


                    {/* Filter Content */}
                    <div className="p-6">
                        <FilterLeads
                            leads={lead}
                            filters={filters}
                            setFilters={setFilters}
                            handleFilterChange={handleFilterChange}
                            handleDateRangeChange={handleDateRangeChange}
                            companyData={companyData}
                            setShowFilters={setShowFilters}
                        />
                    </div>
                </div>
                {/* Background Overlay (optional) */}
                {showFilters && <div onClick={() => setShowFilters(false)} className="lg:hidden fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-20"></div>}
            </>
            {isInitialLeadsLoading ? (
                <div className="min-h-[calc(100vh-6rem)] flex flex-col lg:hidden justify-center items-center h-full bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF]">
                    <div className="animate-spin rounded-full border-2 mb-2 border-t-2 border-orange-500 border-t-gray-200 h-8 w-8"></div>
                    <p className='text-sm font-medium'>Fetching Leads...</p>
                </div>
            ) : (<div>
                {/* Filter Section */}
                {sortedLeads?.length === 0 ? (
                    <div className="min-h-[calc(100vh-6rem)] lg:hidden bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF] flex justify-center items-center ">
                        <div className="flex flex-col items-center">
                            <img
                                src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Search_image.png"
                                alt="Search"
                                className="h-[116px] w-[122px] mb-6"
                            />
                            <p className="text-md font-semibold text-[#3C3C3C] text-center">
                                You can't submit any quotations to the buyer.
                                <br /> Please open and submit the quote for the RFQ you received.
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="lg:hidden py-2 ">
                        {/* filter options */}
                        {/* <div className="relative flex justify-start lg:hidden bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF] gap-2 py-2 px-4">
                            <button onClick={handleFilters} className="hidden font-semibold bg-white text-sm rounded-md border border-solid lg:w-[100px] px-4 py-2 my-auto shadow-md">Filters</button>
                            <div className="flex justify-start gap-2 items-center">
                                <button
                                    onClick={() => handleFilters(null)}
                                    className={`border border-black rounded-sm px-4 py-1 ${filters.quotationReceived === null ? "bg-black text-white" : ""
                                        }`}
                                >
                                    All
                                </button>
                                <button
                                    onClick={() => handleFilters(false)}
                                    className={`border border-black rounded-sm px-4 py-1 ${filters.quotationReceived === false ? "bg-black text-white" : ""
                                        }`}
                                >
                                    Pending
                                </button>
                                <button
                                    onClick={() => handleFilters(true)}
                                    className={`border border-black rounded-sm px-4 py-1 ${filters.quotationReceived === true ? "bg-black text-white" : ""
                                        }`}
                                >
                                    Submitted
                                </button>
                            </div>
                        </div> */}


                        {/* <FilterLeads
                                                filters={filters}
                                                handleFilterChange={handleFilterChange}
                                                /> */}
                        <div className="block lg:hidden overflow-y-auto bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF] px-4" style={{ height: "700px" }}>
                            {sortedLeads.map((lead, index) => (
                                <div
                                    onClick={() => openQuotationForm(lead)}
                                    key={index}
                                    className="bg-white p-4 mb-2 shadow-md rounded-md border"
                                >
                                    <p
                                        className="text-sm break-words w-full cursor-pointer hover:underline"
                                        onClick={() => openQuotationForm(lead)}
                                    >
                                        <span className="text-gray-600">RFQ Subject : </span>
                                        <span className="text-blue-500">{lead?.name || "N/A"}</span>
                                    </p>



                                    <p className="text-sm ">
                                        <span className="text-gray-600"> RFQ No. : </span>
                                        {lead?.rfqId || "N/A"}
                                    </p>
                                    <p className="text-sm ">
                                        <span className="text-gray-600"> Project Name : </span>
                                        {lead?.projectName || "N/A"} ({lead?.location})
                                    </p>
                                    {/* <h2 className="font-bold text-sm text-gray-800 mb-2">{lead.name || "N/A"}</h2> */}
                                    {/* <div className="flex items-center justify-between"> */}
                                    {/* <p className="text-sm ">
                                        <span className="text-gray-600"> Requirement Type: </span>
                                        {lead.rfqType ? capitalizeFirstLetter(lead.rfqType) : "N/A"}
                                    </p> */}

                                    {/* Quotation Status */}
                                    {/* <p className="text-sm ">
                                        <span className="text-gray-600">Quotation Status: </span>
                                        {lead?.suppliers?.[0]?.quotationReceived
                                            ? "Submitted"
                                            : "Pending"}
                                    </p> */}
                                    {/* </div> */}

                                    <p className="text-sm ">
                                        <span className="text-gray-600">Client Name: </span>
                                        {lead.userBusinessName || "N/A"}
                                    </p>

                                    {lead?.status === "CLOSED" && (
                                        <div className="mt-2 flex items-center gap-2 text-sm">
                                            <span className="text-gray-600">Award Status: </span>
                                            {renderAwardStatusBadge(lead)}
                                        </div>
                                    )}
                                    {lead?.status === "CLOSED" && (
                                        <div className="mt-1 flex items-center gap-2 text-sm">
                                            <span className="text-gray-600">Awarded Amount: </span>
                                            <span className="font-semibold text-[#3e4652]">{renderAwardedAmount(lead)}</span>
                                        </div>
                                    )}



                                    <div className="flex justify-between items-center">
                                        {/* <p className="text-sm ">
                                            <span className="text-gray-600">RFQ Status: </span>
                                            {lead.status || "N/A"}
                                        </p> */}
                                        <p className="text-sm ">
                                            <span className="text-gray-600">Created Date: </span>
                                            {lead.createdAt
                                                ? `${new Date(lead.createdAt).getDate()}/${monthNames[new Date(lead.createdAt).getMonth()]}/${new Date(lead.createdAt).getFullYear()}`
                                                : "N/A"}
                                        </p>
                                        {/* <button
                                            className="px-2 py-1 mt-2 shadow-md text-xs rounded-sm border whitespace-normal border-black"
                                            onClick={() => openQuotationForm(lead)}
                                        >
                                            Add Quotation
                                        </button> */}
                                        <button
                                            onClick={() => openQuotationForm(lead)}
                                            className="px-2 py-1 self-center w-[115px] text-xs whitespace-nowrap flex items-center gap-1 border border-gray-400"
                                        >
                                            <img
                                                src={
                                                    lead?.suppliers?.[0]?.quotationReceived
                                                        ? "https://storagereponeevaydevcdn.blob.core.windows.net/business/clock.svg"
                                                        : "https://storagereponeevaydevcdn.blob.core.windows.net/business/pending.svg"
                                                }
                                                alt=""
                                                className="w-[10px] h-[10px]"
                                            />
                                            {getQuotationActionLabel(lead)}
                                        </button>
                                    </div>
                                </div>
                            ))}

                        </div>
                        <div className="lg:hidden sticky bottom-[56px] z-20 pagination">{renderPaginationControls()}</div>
                    </div>)}
            </div>)}

            <div
                className="sticky lg:hidden bottom-0 bg-white flex justify-between"
                style={{
                    boxShadow: "0 -4px 6px -2px rgba(0, 0, 0, 0.1)", // Top shadow
                }}
            >
                <button onClick={handleMyBusiness} className="w-1/2  p-4 hover:bg-gray-100 border-r border-black">My Business</button>
                <button onClick={handleLeads} className="w-1/2 p-4 hover:bg-gray-100">Requirements</button>
            </div>


            {/* desktop */}
            <div className="hidden lg:block">
                <SidePanel>
                    <div className="w-full h-screen bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF]">
                        <div className="bg-white sticky top-0 z-20 shadow-md p-4">
                            <h1 className="text-base font-bold">Leads</h1>
                        </div>

                        {isInitialLeadsLoading ? (
                            <div className="flex flex-col justify-center items-center h-screen">
                                <div className="animate-spin rounded-full border-2 mb-2 border-t-2 border-orange-500 border-t-gray-200 h-8 w-8"></div>
                                <p className='text-sm font-medium'>Fetching Leads...</p>
                            </div>
                        ) : (
                            <div className="px-2 pt-2 lg:w-full min-h-[calc(100vh-5rem)]  bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF]">
                                <>
                                    {/* Leads Section */}
                                    {/* {filteredLeads.length === 0 ? (
                                    <div className=" h-full w-full p-auto">No leads found for the selected filters.</div>
                                ) : ( */}
                                    {!hasLoadedOnce && lead?.leads?.length === 0 ? (
                                        <div className="min-h-[calc(100vh-6rem)] flex justify-center items-center ">
                                            <div className="flex flex-col items-center">
                                                <img
                                                    src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Search_image.png"
                                                    alt="Search"
                                                    className="h-[116px] w-[122px] mb-6"
                                                />
                                                <p className="text-md font-semibold text-[#3C3C3C] text-center">
                                                    You can't submit any quotations to the buyer.
                                                    <br /> Please open and submit the quote for the RFQ you received.
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="flex justify-start gap-x-2 min-h-[calc(100vh-6rem)]">

                                                {/* Always Visible Filters Panel */}
                                                <FilterLeads
                                                    leads={lead}
                                                    filters={filters}
                                                    setFilters={setFilters}
                                                    handleFilterChange={handleFilterChange}
                                                    handleDateRangeChange={handleDateRangeChange}
                                                    companyData={companyData}
                                                // filteredData={filteredData}
                                                />

                                                <>
                                                    {/* <SidePanel> */}
                                                    <div className=" overflow-x-auto bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF]">                                                        <style>
                                                            {`
                                                                 .leads-table-scroll {
                                                                  scrollbar-width: thin;
                                                                  scrollbar-color: #c7ced8 #f8fafc;
                                                                 }

                                                                 .leads-table-scroll::-webkit-scrollbar {
                                                                   height: 3px;
                                                                   width: 3px;
                                                                  }

                                                                 .leads-table-scroll::-webkit-scrollbar-track {
                                                                  background-color: #f8fafc;
                                                                  border-radius: 999px;
                                                                  }

                                                                 .leads-table-scroll::-webkit-scrollbar-thumb {
                                                                  background-color: #c7ced8;
                                                                  border-radius: 999px;
                                                                  }

                                                                 .leads-table-scroll::-webkit-scrollbar-thumb:hover {
                                                                  background-color: #9aa4b2;
                                                                  }
                                                            `}
                                                        </style>

                                                        <>
                                                            {/* <div> */}
                                                            <div className="rounded-md mb-8 bg-white shadow-md h-[calc(100vh-6rem)] hidden lg:flex lg:flex-col overflow-hidden">
                                                                <div className="leads-table-scroll relative flex-1 overflow-auto">
                                                                    {isTableRefreshing && (
                                                                        <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/65 backdrop-blur-[1px]">
                                                                            <div className="flex items-center gap-2 rounded-full border border-orange-100 bg-white px-4 py-2 text-xs font-semibold text-orange-600 shadow-sm">
                                                                                <span className="h-4 w-4 animate-spin rounded-full border-2 border-orange-500 border-t-transparent"></span>
                                                                                Updating leads...
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    <table className=" min-w-full table-auto flex-grow">
                                                                        <thead className="bg-gray-100 sticky top-0 z-10">
                                                                            <tr>
                                                                                {tableHeaders.map((header) => (
                                                                                    <th
                                                                                        key={header.key}
                                                                                        className="text-left text-xs py-3 whitespace-nowrap text-[#727269] font-bold px-4"
                                                                                    >
                                                                                        {header.label}
                                                                                    </th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        {sortedLeads?.length === 0 ? (
                                                                            <div className=" flex justify-center items-center h-full w-full absolute">
                                                                                <div className="flex flex-col items-center">
                                                                                    <img
                                                                                        src="https://storagereponeevaydevcdn.blob.core.windows.net/business/Search_image.png"
                                                                                        alt="Search"
                                                                                        className="h-[116px] w-[122px] mb-4"
                                                                                    />
                                                                                    <p className="text-sm text-[#3C3C3C] text-center">
                                                                                        No matching result found for this filter combination

                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        ) : (<tbody>
                                                                            {sortedLeads.map((lead, index) => (
                                                                                <tr key={index} className={`  ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                                                                                    {tableHeaders.map((header) => (
                                                                                        <td
                                                                                            key={header.key}
                                                                                            className={`text-xs text-[#3e4652] px-4 py-2 ${header.key === "name" || header.key === "userBusinessName"
                                                                                                ? "min-w-[280px] max-w-[280px] text-start whitespace-normal break-words"
                                                                                                : header.key === "actions"
                                                                                                    ? "text-center"
                                                                                                    : header.key === "requesterName"
                                                                                                        ? "min-w-[200px] text-left whitespace-normal break-words"
                                                                                                        : header.key === "rfqId"
                                                                                                            ? "text-right"
                                                                                                            : header.key === "projectName"
                                                                                                                ? "min-w-[240px] text-left whitespace-normal break-words"
                                                                                                                : header.key === "awardSummary"
                                                                                                                    ? "min-w-[140px] text-center"
                                                                                                                    : header.key === "awardedAmount"
                                                                                                                        ? "min-w-[150px] text-right whitespace-nowrap"
                                                                                                                        : "text-start" // Default alignment for all other columns
                                                                                                }`}
                                                                                        >

                                                                                            {/* Cell content */}
                                                                                            {header.key === "name" ? (
                                                                                                <button
                                                                                                    onClick={() => openQuotationForm(lead)}
                                                                                                    className="text-[#3f83f8] text-start hover:cursor-pointer font-semibold"
                                                                                                >
                                                                                                    {lead[header.key] || "N/A"}
                                                                                                </button>
                                                                                            ) : header.key === "actions" ? (
                                                                                                <div className="flex justify-center items-center">
                                                                                                    <button
                                                                                                        onClick={() => openQuotationForm(lead)}
                                                                                                        className="px-2 py-1 self-center w-[115px] text-xs whitespace-nowrap flex items-center gap-1 border border-gray-400"
                                                                                                    >
                                                                                                        <img
                                                                                                            src={
                                                                                                                lead?.suppliers?.[0]?.quotationReceived
                                                                                                                    ? "https://storagereponeevaydevcdn.blob.core.windows.net/business/clock.svg"
                                                                                                                    : "https://storagereponeevaydevcdn.blob.core.windows.net/business/pending.svg"
                                                                                                            }
                                                                                                            alt=""
                                                                                                            className="w-[10px] h-[10px]"
                                                                                                        />
                                                                                                        {getQuotationActionLabel(lead)}
                                                                                                    </button>
                                                                                                </div>
                                                                                            ) : header.key === "rfqType" ? (
                                                                                                capitalizeFirstLetter(lead[header.key] || "N/A")
                                                                                            ) : header.key === "createdAt" ? (
                                                                                                lead[header.key]
                                                                                                    ? `${new Date(lead[header.key]).getDate()}/${monthNames[new Date(lead[header.key]).getMonth()]}/${new Date(lead[header.key]).getFullYear()}`
                                                                                                    : "N/A"
                                                                                            ) : header.key === "status" ? (
                                                                                                <span className={`inline-flex items-center rounded px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${getRfqStatusClass(lead?.status)}`}>
                                                                                                    {formatRfqStatus(lead?.status)}
                                                                                                </span>
                                                                                            ) : header.key === "projectName" ? (
                                                                                                <div className="whitespace-normal break-words">
                                                                                                    <p>{lead.projectName || "N/A"}</p>
                                                                                                    <p className="text-gray-500 text-xs">{lead.location || "N/A"}</p>
                                                                                                </div>
                                                                                            ) : header.key === "quotationReceived" ? (
                                                                                                lead?.suppliers?.[0]?.quotationReceived ? "Submitted" : "Pending"
                                                                                            ) : header.key === "awardSummary" ? (
                                                                                                renderAwardStatusBadge(lead)
                                                                                            ) : header.key === "awardedAmount" ? (
                                                                                                renderAwardedAmount(lead)
                                                                                            ) : (
                                                                                                lead[header.key] || "N/A"
                                                                                            )}
                                                                                        </td>
                                                                                    ))}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>)}

                                                                    </table>
                                                                </div>
                                                                <div className="desktop-leads-pagination shrink-0">{renderPaginationControls()}</div>
                                                            </div>
                                                        </>
                                                    </div>
                                                    {/* </SidePanel> */}
                                                </>
                                            </div>
                                        </>
                                    )}
                                </>
                            </div>)}
                    </div >
                </SidePanel >
            </div >
        </div>
    );
};

export default LeadsNew;









